import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { t } from '@/plugins/i18n'
import { computed } from 'vue'
import { codeName } from '@/components/BlackGoods/data'

export default /*#__PURE__*/_defineComponent({
  props: ['item'],
  setup(__props) {

const props = __props

const errorText = computed(() => {
  return props.item?.blackTag === 1 && codeName[props.item?.blackReasonCode]?.strict
})

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", { class: "black-warning-tip" }, _toDisplayString(_unref(errorText)), 513)), [
    [_vShow, _unref(errorText)]
  ])
}
}

})